<template>
    <v-container fluid>
        <div v-for="(data, index) in leaderboardData" :key="index">
            <div class="leaderboard-item">
                <div class="leaderboard-item-left">
                    <img
                        :src="
                            index === 0
                                ? require('../assets/trophy1.png')
                                : index === 1
                                ? require('../assets/trophy2.png')
                                : index === 2
                                ? require('../assets/trophy3.png')
                                : require('../assets/trophy_remaining.png')
                        "
                        alt="random pic"
                    />
                    <div>
                        <h3>{{ data.name }}</h3>
                        <p class="text-sm">
                            Donated {{ data.electricityDonated }}kWh of energy
                        </p>
                    </div>
                </div>
                <div class="leaderboard-item-right">
                    <p>{{ data.recentActivity }}</p>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
import { mockLeaderboardData } from "../utils/mockData";
export default {
    name: "MarketplaceView",
    data() {
        return {
            leaderboardData: Array,
        };
    },
    created() {
        this.leaderboardData = mockLeaderboardData;
    },
};
</script>
<style scoped>
.leaderboard-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #f4f4f4;
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 5px;
}
.leaderboard-item-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
}
.leaderboard-item-right p {
    color: grey;
}
img {
    width: 50px;
}
</style>
